export default {
  loadFailed: "Неуспешно зареждане на тестовете. Проверете връзката и опитайте отново.",
  page_header: {
    title: "Тестове",
    description: "Управление на лабораторни тестови дефиниции, съответствия и процесори.",
  },

  toolbar: {
    refresh: "Обновяване",
  },

  table: {
    search_placeholder: "Търсене на тестове",
    new_test: "Добавяне на тест",
    columns: {
      instrument: "Апарат",
      name: "Име на тест",
      test_code: "Код / Синоним",
      test_code_tooltip: "Кодът, изпращан от апарата за идентификация на показателя.",
      modifier: "Модификатор",
      modifier_tooltip: "Допълнителен разграничител, когато същият тест код дава резултати от различен тип.",
      direction: "Посока",
      direction_tooltip: "Управлява начина, по който Iris насочва данните.",
      result_type: "Тип",
      result_type_tooltip: "Форматът на стойността на резултата.",
      scale: "Десетични знаци",
      scale_tooltip: "Брой десетични знаци при показване на числовите резултати за теста.",
      status: "Статус",
      created_time: "Дата / Час",
      created_time_tooltip: "Датата и часът на създаване на теста.",
      actions: "Действия",
    },
    empty: {
      title: "Няма налични тестове",
      description: "Все още няма конфигурирани тестови дефиниции.",
    },
    no_results: "Няма тестове, съответстващи на '{query}'",
    status_enabled: "Активен",
    status_disabled: "Деактивиран",
    collapse_group: "Свиване на групата",
    expand_group: "Разгъване на групата",
    actions: {
      edit: "Редактиране на тест",
      delete: "Изтриване",
    },
  },

  editor: {
    title_create: "Добавяне на тест",
    title_edit: "Редактиране на тест",
    subtitle_create: "Конфигуриране на нова тестова дефиниция за избрания апарат",
    subtitle_instrument: "Апарат",
    subtitle_test: "Тест",
    add: "Добавяне на тест",
    save: "Запазване на промените",
    reset: "Възстановяване",
    cancel: "Отказ",

    tabs: {
      basic_data: "Основни данни",
      mappings: "LIS съответствия",
      processors: "Процесори",
    },

    fields: {
      instrument: "Апарат",
      name: "Име на тест",
      test_code: "Код",
      modifier: "Модификатор",
      direction: "Посока",
      result_type: "Тип резултат",
      scale: "Десетични знаци",
      is_filter: "Филтър тест",
      is_filter_on_title: "Филтрира резултати",
      is_filter_off_title: "Не филтрира резултати",
      is_disabled: "Деактивиран",
      is_disabled_on_title: "Тестът е деактивиран",
      is_disabled_off_title: "Тестът е активен",
      activate: "Активиране",
      deactivate: "Деактивиране",
      modifier_placeholder: "напр. STAT",
      scale_placeholder: "напр. 2",
    },

    hints: {
      instrument: "Апаратът, към който е свързан този тест.",
      name: "Човешко-четимо име за тази тестова дефиниция.",
      test_code: "Код на показателя от апарата.",
      modifier:
        "Допълнителен модификатор за разграничаване на варианти на един и същ тест код. напр.: синоним*модификатор.",
      direction: "Дали тестът само се поръчва, изработва или и двете.",
      result_type: "Типът данни на стойността на резултата: количествен, текстов или друг.",
      scale: "Брой цифри след десетичен знак.",
      is_filter_on: "Резултатите с този тест ще бъдат задържани за филтриране",
      is_filter_off: "Резултатите с този тест няма да преминават през филтриране",
      is_disabled_on: "Тестът няма да приема нови поръчки или резултати",
      is_disabled_off: "Тестът приема поръчки и резултати нормално",
    },

    validation: {
      test_code_required: "Тест кодът е задължителен",
      name_required: "Името на теста е задължително",
      test_code_max_length: "Тест кодът трябва да е до 50 символа",
      test_code_duplicate: "Вече има тест с този код за този апарат",
      name_max_length: "Името трябва да е до 255 символа",
      modifier_max_length: "Модификаторът трябва да е до 50 символа",
      scale_min: "Скалата трябва да е поне 0",
      scale_max: "Скалата трябва да е най-много 10",
    },
  },

  directions: {
    bidirectional: "Двупосочен",
    orders_only: "Само поръчки",
    results_only: "Само резултати",
  },

  result_types: {
    quantitative: "Количествен",
    semiquantitative: "Полуколичествен",
    qualitative: "Качествен",
    text: "Текстов",
    ratio: "Съотношение",
    predefined_list: "Предефиниран списък",
    arbitrary: "Арбитражен",
    antibiotic_susceptibility: "Антибиотична чувствителност",
    image: "Изображение",
  },

  direction_hints: {
    bidirectional: "Използва се за поръчки и резултати",
    results_only: "Само резултати — не се поръчва към апарата",
    orders_only: "Само поръчки — не връща резултати",
  },

  result_type_hints: {
    quantitative: "Количествен резултат — числова стойност, напр. 3, 4.5",
    semiquantitative: "Полуколичествен резултат — степени, нива или диапазони",
    qualitative: "Качествен резултат — Положителен, Отрицателен, Сива зона",
    text: 'Текстов резултат — свободен текст, напр. "Червено", "Бледо"',
    ratio: "Резултат като съотношение, напр. 1:2, 1:4",
    predefined_list: "Резултат от предварително дефиниран списък със стойности",
    arbitrary: 'Арбитражен резултат — символи или означения, напр. "+", "2+", "-"',
    antibiotic_susceptibility: "Антибиотична чувствителност — напр. S, I, R",
    image: "Изображение — двоични данни",
  },

  mappings: {
    title: "Съответствия",
    add: "Добавяне на съответствие",
    edit: "Редактиране на съответствие",
    done: "Готово",
    columns: {
      mapping_key: "LIS ID",
      lis_name: "LIS име",
      created_time: "Дата / Час",
      actions: "Действия",
    },
    add_subtitle: "Конфигурирайте ново съответствие за този тест.",
    subtitle_test: "Код на тест",
    subtitle_id: "ID на тест",
    subtitle_created: "Създаден",
    subtitle_lis_id: "LIS ID",
    subtitle_test_code_tooltip: "Код на теста за LIS нареждания",
    subtitle_id_tooltip: "Системен идентификатор на родителския тест",
    subtitle_lis_id_tooltip: "LIS ключ за маршрутиране на резултатите",
    subtitle_created_tooltip: "Дата на създаване на съответствието",

    date_created: "Създаден",
    date_modified: "Последно променен",
    hints: {
      mapping_key: "Уникалното ID, с което LIS системата идентифицира теста.",
      lis_name: "Наименованието, използвано от LIS системата за теста.",
    },
    empty: "Няма дефинирани съответствия",
    delete_confirm: {
      title: "Премахване на съответствие",
      message: "Това съответствие ще бъде премахнато.",
    },
    validation: {
      mapping_key_required: "LIS ID е задължителен",
      mapping_key_too_long: "LIS ID трябва да е най-много 100 символа",
      mapping_key_duplicate: "Вече съществува съответствие с този ключ",
      lis_name_required: "LIS името е задължително",
      lis_name_too_long: "LIS името трябва да е най-много 255 символа",
    },
    unsaved_dialog_title: "Незапазени промени",
    unsaved_save_and_leave: "Запазване и продължаване",
    unsaved_discard: "Отхвърляне",
    unsaved_stay: "Оставане",
  },

  processors: {
    title: "Процесори",
    add: "Добавяне на процесор",
    edit: "Редактиране на процесор",
    done: "Готово",
    columns: {
      rank: "Позиция",
      active: "Активен",
      status: "Статус",
      content: "Формула",
      created_time: "Дата / Час",
      actions: "Действия",
    },
    status_active: "Активен",
    status_inactive: "Неактивен",
    add_subtitle: "Конфигурирайте нов процесор за този тест.",
    subtitle_rank_tooltip: "Ред на изпълнение — по-нисък ранг се изпълнява първи",
    subtitle_type_tooltip: "Тип процесор (скриптов, числов или текстов)",
    subtitle_status_tooltip: "Дали процесорът се изпълнява при обработка на резултати",
    date_created: "Създаден",
    date_modified: "Последно променен",
    hints: {
      rank: "Ред на изпълнение — по-ниската позиция се изпълнява първа.",
      active: "Когато е деактивиран, процесорът се прескача при обработката.",
      active_on: "Процесорът е активен и участва в обработката на резултати",
      active_off: "Процесорът е изключен и няма да участва в обработката на резултати",
      content: "JavaScript израз, изчисляван спрямо обекта резултат.",
    },
    empty: "Няма дефинирани процесори",
    delete_confirm: {
      title: "Премахване на процесор",
      message: "Този процесор ще бъде премахнат.",
    },
    validation: {
      rank_min: "Позицията трябва да е най-малко 1",
      rank_duplicate: "Вече съществува процесор с тази позиция",
      then_action_required: "Добавете поне едно действие в 'Тогава'",
      then_text_value_required: "Текстовата стойност е задължителна",
    },
    unsaved_dialog_title: "Незапазени промени",
    unsaved_save_and_leave: "Запазване и продължаване",
    unsaved_discard: "Отхвърляне",
    unsaved_stay: "Оставане",
    types: {
      js: "JavaScript скрипт",
      num: "Числови условия",
      txt: "Текстови условия",
    },
    type_label: "Тип процесор",
    type_hint: "Изберете типа логика за обработка на този процесор.",
    script_label: "Скрипт (JavaScript)",
    when_label: "Когато",
    then_label: "Тогава",
    comparison_label: "Сравнение",
    value_label: "Стойност",
    value2_label: "До",
    then_text_value_label: "Текстова стойност",
    then_numeric_prefix_label: "Числов префикс",
    then_numeric_value_label: "Числова стойност",
    then_to_be_filtered_label: "Филтриране от LIS",
    then_to_be_filtered_hint: "Когато условието е изпълнено, резултатът ще бъде задържан и няма да достигне до LIS",
    then_to_be_filtered_on_title: "Филтриран — не достига до LIS",
    then_to_be_filtered_off_title: "Не филтриран — изпраща се към LIS",
    then_to_be_filtered_on_hint: "Когато условието е изпълнено, резултатът ще бъде задържан и няма да достигне до LIS",
    then_to_be_filtered_off_hint: "Резултатът ще бъде изпратен към LIS нормално",
    then_text_value_hint: "Заменя текстовия етикет, показван за този резултат",
    then_numeric_prefix_hint: "Префикс, показван преди числовата стойност, напр. '>' или '<'",
    then_numeric_value_hint: "Заменя числовата стойност, съхранявана за този резултат",
    flags_label: "Флагове",
    flags_hint: "Флаговете се прикачат към резултата, когато условието е изпълнено",
    add_flag: "Добавяне на флаг",
    no_flags: "Няма дефинирани флагове",
    flag_number: "Флаг {n}",
    flag_code_label: "Код на флаг",
    flag_value_label: "Описание на флаг",
    flag_level_label: "Ниво на флаг",
    when_values_label: "Стойности за съвпадение",
    add_when_value: "Добавяне на стойност",
    no_when_values: "Няма дефинирани стойности за съвпадение",
    when_value_number: "Стойност {n}",
    js_name_label: "Наименование на процесора",
    js_name_hint: "Незадължително четимо наименование за скрипт процесора",
    when_exclusive_hint: "По-малко и по-голямо са изключващи — граничната стойност не се включва",
    when_between_hint: "Между е включващо — граничните стойности се включват",
    txt_when_hint: "Въведете стойност и натиснете Enter или кликнете +, за да я добавите",
    txt_isnull_hint: "Прилага се, когато текстовият резултат е празен или null",
    comparisons: {
      less_than: "По-малко от",
      equal: "Равно на",
      greater_than: "По-голямо от",
      is_null: "Е празно",
      between: "Между",
      contains: "Съдържа",
      starts_with: "Започва с",
      ends_with: "Завършва с",
    },
    flag_levels: {
      info: "Информативно",
      warning: "Внимание",
      error: "Грешка",
      critical: "Критично",
    },
    summary: {
      filtered: "филтриран от LIS",
      prefix: "префикс",
      flag: "флаг",
      js_script: "JS скрипт",
    },
    preview: {
      value_var: "стойност",
      text_var: "текст",
    },
  },

  delete_dialog: {
    title: "Потвърждаване на изтриване",
    subtitle: "На път сте да изтриете тест: {name}",
    subtitle_test: "Тест",
    subtitle_id: "ID на тест",
    subtitle_name_tooltip: "Показвано наименование на теста",
    subtitle_id_tooltip: "Системен идентификатор на теста",
    warning: "Тестът и всички свързани с него данни ще бъдат трайно изтрити.",
    has_related_items: "Тестът не може да бъде изтрит, защото има свързани съответствия или обработващи правила.",
    confirm: "Изтриване",
    cancel: "Отказ",
  },

  snackbar: {
    create_success: "Тестът е създаден успешно",
    update_success: "Тестът е актуализиран успешно",
    delete_success: "Тестът е изтрит успешно",
    create_failed: "Неуспешно създаване на тест",
    update_failed: "Неуспешна актуализация на тест",
    delete_failed: "Неуспешно изтриване на тест",
    fetch_failed: "Неуспешно зареждане на тестове",
    mapping_added: "Съответствието е добавено",
    mapping_updated: "Съответствието е обновено",
    mapping_removed: "Съответствието е премахнато",
    mapping_add_failed: "Неуспешно добавяне на съответствие",
    mapping_remove_failed: "Неуспешно премахване на съответствие",
    processor_added: "Процесорът е добавен",
    processor_updated: "Процесорът е обновен",
    processor_removed: "Процесорът е премахнат",
    processor_add_failed: "Неуспешно добавяне на процесор",
    processor_remove_failed: "Неуспешно премахване на процесор",
    reset_success: "Основните данни са възстановени",
  },
};
